// extracted by mini-css-extract-plugin
export default {"row":"row--08c9d00d","leftFixed":"leftFixed--a387fe1c"};